import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Col,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane
} from 'reactstrap';
import classnames from 'classnames';
import { ResultApi } from "../../services/services";
import LineChart from "../../../components/Chart/LineChart";
import ReportTable from "../components/reports/ReportTable";
import BarChartReport from "../components/reports/barChartReport";
import ReportPieChart from "../components/reports/ReportPieChart";
import MapReport from "../components/reports/MapRepot";
import { ReportBarChartTransformer } from "../../services/chart.transformer";
import { CSVLink } from 'react-csv';

const Report = (props) => {
    const scrollRef = useRef()
    const [activeTab, setActiveTab] = useState('1');
    const [result, setResult] = useState(null)
    const [barChartData, setBarChartData] = useState([]);
    const [csvData, setCSVData] = useState([]);
    const tabsIds = [
        { id: '1', name: "روند" },
        { id: '2', name: "جدول" },
        { id: '3', name: "نمودار میله ای" },
        { id: '4', name: "نقشه" },
        { id: '5', name: "نمودار دایره ای" },
    ]
    const Result = useCallback(async () => {
        const result = await ResultApi([props.tableData.id])
        await setResult(result?.data)
        await prepareBarChartData(result?.data);
        prepareCSVData(result?.data);
    })

    useEffect(() => {
        Result()
        executeScroll()
    }, [scrollRef])

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const executeScroll = () => {
        scrollRef?.current?.scrollIntoView({
            behavior: "auto",
            block: "end"
        })
    }

    const prepareBarChartData = (data) => {
        if (data[0]?.unit === "تعداد") {
            const res = [];

            data[0]?.values.map(v => {
                const values = v.values.filter(f => f.locationCode !== "98");
                res.push({ ...v, values });
            });

            setBarChartData(res);
        } else {
            setBarChartData(data[0]?.values)
        }
    }

    const prepareCSVData = (data) => {
        const res = []
        if (data[0]?.values) {
            data[0]?.values.map(v => res.push(...v.values));
        }
        setCSVData(res);
    }

    const csvHeaders = [
        { label: "استان", key: "locationName" },
        { label: "سال", key: "year" },
        { label: "مقدار", key: "value" }
    ];

    const csvReport = {
        data: csvData,
        headers: csvHeaders,
        filename: 'data.csv'
    };

    return (
        <div className={'col-xs-12'} ref={scrollRef}>
            <Card >
                <CardBody>
                    <Nav tabs>
                        {result && tabsIds && tabsIds.map(tab => {
                            if (tab.id !== '5' || (tab.id === '5' && result[0].pie.length > 0)) {
                                return (
                                    <NavItem className={`reportTab`} key={tab.id}>
                                        <NavLink
                                            key={tab.id}
                                            className={classnames({ active: activeTab === tab.id })}
                                            onClick={() => {
                                                toggle(tab.id)
                                            }}>
                                            {tab.name}
                                        </NavLink>
                                    </NavItem>
                                )
                            }
                        })
                        }

                    </Nav>
                    <div className={"reportTools"}>
                        <CSVLink className={"btn btn-warning exportToCSV"} color="warning" {...csvReport}>دریافت مقادیر</CSVLink>
                        <Button color="warning" onClick={props.Comparison} className="comparison">
                            مقایسه
                        </Button>
                    </div>
                    <Row className="result-title text-right">
                        <Col>
                            <p>{result != null ? result[0]?.title : null}</p>
                        </Col>
                    </Row>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <Row className={'p-3'}>
                                <Col sm="12">
                                    <Card>
                                        <CardHeader className={"text-right "}>
                                            <h5 className="card-category">نمودارخطی</h5>
                                        </CardHeader>
                                        <CardBody>
                                            <div className="chart-area" style={{ minHeight: 300 }}>
                                                {result && <LineChart
                                                    datasets={result[0]?.trend}
                                                    title={result?.title}
                                                />}
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tabId="2">
                            <Row className={'p-3'}>
                                {result &&
                                    <ReportTable
                                        data={result[0]?.values}
                                        title={result?.title}
                                    />
                                }
                            </Row>
                        </TabPane>
                        <TabPane tabId="3">
                            <Row className={'p-3'}>
                                {result &&
                                    <BarChartReport
                                        transformer={ReportBarChartTransformer}
                                        data={barChartData}
                                        title={result?.title}
                                    />
                                }
                            </Row>
                        </TabPane>
                        <TabPane tabId="4">
                            <Row className={'p-3'}>
                                {result &&
                                    <MapReport
                                        chartdata={result[0]?.values}
                                        quarters={result[0]?.quarters}
                                        title={result?.title}
                                        years={result[0]?.years} />
                                }
                            </Row>
                        </TabPane>
                        {result && result[0]?.pie.length !== 0 &&
                            <TabPane tabId="5">
                                <Row className={'p-3'}>
                                    <ReportPieChart
                                        data={result[0]?.pie}
                                        title={result?.title}
                                        years={result[0]?.years}
                                    />
                                </Row>
                            </TabPane>
                        }
                    </TabContent>

                </CardBody>
            </Card>
        </div>
    );
}

export default Report;